import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";

import router from "./router";
import store from "./store";

require("@/store/subscriber");

require("./mixin.js");
require("./axios.js");
require('./filters.js')

Vue.config.productionTip = false;

import VueDocPreview from "vue-doc-preview";
Vue.component("VueDocPreview", VueDocPreview);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);


store.dispatch("auth/attempt", localStorage.getItem("token")).then(() => {
  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount("#app");
});
